import React from 'react';
import PropTypes from 'prop-types';
import ReduxModal from 'components/reduxModal';

export const MODAL_ID = 'confirm-dialog';

const ConfirmDialog = ({ close }) => (
  <ReduxModal
    id={MODAL_ID}
  >
    {(Modal, { extra }) => (
      <div>
        <Modal.Heading title={extra.title} subtitle={extra.subtitle} />
        <Modal.Footer>
          <button type="button" onClick={close} className="stroke-btn has-margin-left">Zamknij</button>
          <button type="button" onClick={() => {extra.submit(); close()}} className="full-btn has-margin-left">{extra.primary || 'Usuń'}</button>
        </Modal.Footer>
      </div>
    )}
  </ReduxModal>
);

ConfirmDialog.propTypes = {
  close: PropTypes.func.isRequired
}

export default ConfirmDialog;


// WEBPACK FOOTER //
// ./src/components/globalModals/ConfirmDialog.jsx